import { Instagram, Phone, Mail } from "lucide-react";

const LOGO_URL = "/brand/24k-logo.jpg";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative border-t border-hairline bg-ink">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-20 grid md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3">
                        <img
                            src={LOGO_URL}
                            alt="24K Glow On The Go"
                            className="w-12 h-12 rounded-full object-cover ring-1 ring-gold/40"
                        />
                        <span className="font-serif text-2xl tracking-[0.12em] uppercase">
                            <span className="text-gold">24K</span> Glow On The Go
                        </span>
                    </div>
                    <p className="mt-4 text-white/60 max-w-md leading-relaxed">
                        The monthly subscription for that <span className="text-gold">24K glow</span> — on the go.
                        Patent-pending AI 3D nail art, unlimited subscription sets, and our Glam on Wheels mobile salon-and-spa.
                    </p>
                    <p className="mt-6 text-xs tracking-[0.25em] uppercase text-gold">Glam on Wheels</p>
                </div>

                <div>
                    <p className="font-serif text-lg mb-4">Visit</p>
                    <ul className="space-y-2 text-white/60 text-sm">
                        <li><a href="#plans" className="hover:text-rose">Plans</a></li>
                        <li><a href="#services" className="hover:text-rose">Services</a></li>
                        <li><a href="#how" className="hover:text-rose">How it works</a></li>
                        <li><a href="#portal-preview" className="hover:text-rose">Client Portal</a></li>
                    </ul>
                </div>

                <div>
                    <p className="font-serif text-lg mb-4">Reach us</p>
                    <ul className="space-y-3 text-white/60 text-sm">
                        <li>
                            <a
                                href="https://www.instagram.com/christinamariesunshine/"
                                target="_blank" rel="noreferrer"
                                data-testid="footer-instagram"
                                className="flex items-center gap-2 hover:text-rose transition"
                            >
                                <Instagram className="w-4 h-4 text-rose" /> @christinamariesunshine
                            </a>
                        </li>
                        <li>
                            <a
                                href="tel:+19046729966"
                                data-testid="footer-phone"
                                className="flex items-center gap-2 hover:text-rose transition"
                            >
                                <Phone className="w-4 h-4 text-rose" /> (904) 672-9966
                            </a>
                        </li>
                        <li>
                            <a
                                href="mailto:glowsupport@monthlyglowonthego.com"
                                data-testid="footer-email"
                                className="flex items-center gap-2 hover:text-rose transition"
                            >
                                <Mail className="w-4 h-4 text-rose" /> glowsupport@monthlyglowonthego.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-hairline">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
                    <p>© {new Date().getFullYear()} 24K Glow On The Go. All rights reserved.</p>
                    <p className="tracking-[0.2em] uppercase">monthlyglowonthego.com</p>
                </div>
            </div>
        </footer>
    );
}
